var _rect, _g, _g2, _g3, _g4, _g5, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser04Big(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 568 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 430,
    height: 358,
    x: 138,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 358,
    fill: "#fff",
    rx: 28,
    transform: "matrix(-1 0 0 1 568 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.316,
    cy: 414.648,
    fill: "url(#b)",
    rx: 412.316,
    ry: 414.648,
    transform: "matrix(-1 0 0 1 971.939 -258.112)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 283,
    x: 68,
    y: 32,
    fill: "#fff",
    rx: 8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M72 48c0-6.627 5.373-12 12-12h349c6.627 0 12 5.373 12 12v246c0 6.627-5.373 12-12 12H84c-6.627 0-12-5.373-12-12V48Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477,
    height: 19,
    x: 20,
    y: 306,
    fill: "#fff",
    rx: 8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M145 97a8 8 0 0 1 8-8h211a8 8 0 0 1 8 8v153a8 8 0 0 1-8 8H153a8 8 0 0 1-8-8V97Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5,
    d: "M246.501 141.5c0-5.983 4.851-10.833 10.834-10.833s10.833 4.85 10.833 10.833v6.5h4.333c6.058 0 9.086 0 11.475.99a13 13 0 0 1 7.036 7.035c.989 2.389.989 5.418.989 11.475h6.5c5.983 0 10.834 4.85 10.834 10.833 0 5.984-4.851 10.834-10.834 10.834h-6.5v7.366c0 7.281 0 10.921-1.417 13.702a13.004 13.004 0 0 1-5.681 5.682c-2.781 1.416-6.421 1.416-13.702 1.416h-3.033v-7.583a9.75 9.75 0 0 0-9.75-9.75 9.75 9.75 0 0 0-9.75 9.75v7.583h-5.2c-7.281 0-10.921 0-13.702-1.416a13.004 13.004 0 0 1-5.681-5.682c-1.417-2.781-1.417-6.421-1.417-13.702v-7.366h6.5c5.983 0 10.833-4.85 10.833-10.834 0-5.983-4.85-10.833-10.833-10.833h-6.5c0-6.057 0-9.086.99-11.475a12.998 12.998 0 0 1 7.035-7.035c2.389-.99 5.418-.99 11.475-.99h4.333v-6.5Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 421,
    height: 323,
    x: 48,
    y: 16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 381,
    height: 278,
    x: 68,
    y: 32,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 517,
    height: 59,
    x: 0,
    y: 290,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 267,
    height: 209,
    x: 125,
    y: 73,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 221.064,
    x2: 258.603,
    y1: 793.112,
    y2: 251.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#700013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF2538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 258.5,
    x2: 258.5,
    y1: 36,
    y2: 306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser04Big);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-04-big.7911ce663b60f15df9f0b04c67d3418e.svg";
export { ForwardRef as ReactComponent };